





































































import { Component, Prop, Vue } from 'vue-property-decorator';
import { RightEnum, TimeAccountDaily } from '@/services/api/nswag/stapiclient_generated';
import {UserStore} from '@/store/user-module';

@Component({
  components: {},
})
export default class TimeAccountDayCell extends Vue {
  @Prop() day!: TimeAccountDaily;
  @Prop({ default: true }) displayDetails!: boolean;

  get canManageTimeAdjustment(): boolean {
    return UserStore.userSettings.CanManageTimeAdjustment;
  }
}
